<template lang="pug">
span {{ currentTime }}
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import LioshutanApi from '@/api';

export default {
  name: 'ServerTime',

  components: {},

  data() {
    return {
      currentTimeOut: '',
      cycleServeTimeOut: '',
    };
  },

  computed: {
    ...mapState({
      currentTime: state => state.common.currentTime,
    }),
  },

  created() {
    this.setServerTime();
    this.clockTimeOut();
  },

  mounted() {
    this.reSetServerTime();
  },

  beforeDestroy() {
    clearTimeout(this.currentTimeOut);
    clearTimeout(this.cycleServeTimeOut);
  },

  methods: {
    async setCurrentTime(time) {
      this.$store.dispatch('common/setCurrentTime', time);
    },

    async setServerTime(){
      const res = await LioshutanApi.common.getServerTime();
      // res.data 是台灣時間 naive string，加 +08:00 確保在非 UTC+8 瀏覽器正確解析
      const serverTime = new Date(res.data.replace(' ', 'T') + '+08:00').toLocaleString('sv-SE', {
        timeZone: 'Asia/Taipei',
        hour12: false,
      }).replace('T', ' ');
      this.setCurrentTime(serverTime);
    },

    clockTimeOut(){
      this.currentTimeOut = setTimeout(() => {
        // 將台灣時間字串正確解析為時間點，加 1 秒後重新格式化
        const currentTs = new Date(this.currentTime.replace(' ', 'T') + '+08:00').getTime();
        const nextTime = new Date(currentTs + 1000).toLocaleString('sv-SE', {
          timeZone: 'Asia/Taipei',
          hour12: false,
        }).replace('T', ' ');
        this.setCurrentTime(nextTime);
        this.clockTimeOut();
      }, 1000);
    },

    reSetServerTime(){
      this.cycleServeTimeOut = setTimeout(() => {
        clearTimeout(this.currentTimeOut);
        this.setServerTime();
        this.currentTimeOut = this.clockTimeOut();
        this.reSetServerTime();
      }, 180000);
    },
  },
};
</script>
